import { render, staticRenderFns } from "./VoipServiceKitRules.vue?vue&type=template&id=164821f9&scoped=true"
import script from "./VoipServiceKitRules.vue?vue&type=script&lang=js"
export * from "./VoipServiceKitRules.vue?vue&type=script&lang=js"
import style0 from "./VoipServiceKitRules.vue?vue&type=style&index=0&id=164821f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164821f9",
  null
  
)

export default component.exports